import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import mapValues from 'lodash/mapValues';
import map from 'lodash/map';
import kebabCase from 'lodash/kebabCase';

/** Сначала значение для светлой темы (light), затем для темной (dark) */

/** Эта функция помогает прокинуть объекту типы для значений минуя сами ключи" */
export var makeColors = function makeColors(colors) {
  return colors;
};
export var getColors = function getColors(colors, prefix) {
  return mapValues(colors, function (color, key) {
    return "var(--color-".concat(prefix, "-").concat(kebabCase(key), ", ").concat(color[0], ")");
  });
};
export var createColorsCssVariables = function createColorsCssVariables(colors, prefix, theme) {
  return map(colors, function (color, key) {
    return "--color-".concat(prefix, "-").concat(kebabCase(key), ": ").concat(color[theme === 'light' ? 0 : 1]);
  }).join(';');
};
//# sourceMappingURL=utils.js.map